import { Language } from '@components/Translations';

export const isDevelopment = import.meta.env.DEV;
export const LOCALE = (localStorage.getItem('locale') ?? 'sv') as Language;

export const BUGSNAG_API_KEY = '0e9d7cfd36cd03f626775283b769a92e';
export const SW_CHECK_UPDATE_INTERVAL = isDevelopment
  ? 1000 * 5
  : 1000 * 60 * 5;
